import { Modal, Button, Textarea, Select } from 'flowbite-react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useRespondContestMaintenance } from '../../hooks';
import ButtonWithLoader from '@/common/components/ui/loading/ButtonLoading';

interface RespondContestModalProps {
  contestId: string;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

const validationSchema = Yup.object({
  resolution: Yup.string()
    .min(5, 'A resposta deve ter pelo menos 5 caracteres')
    .required('Campo obrigatório'),
  status: Yup.string().required('Campo obrigatório')
});

export default function RespondContestModal({
  contestId,
  isOpen,
  setIsOpen,
}: RespondContestModalProps) {
  const { mutate, isPending } = useRespondContestMaintenance();

  const handleClose = () => setIsOpen(false);

  return (
    <Modal show={isOpen} onClose={handleClose}>
      <Modal.Header className="dark:text-black">Responder Contestação</Modal.Header>
      <Formik
        initialValues={{ resolution: '', status: '' }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          mutate({ contestId, resolution: values.resolution, status: values.status });
					handleClose();
        }}
      >
        {({ values, handleChange }) => (
        <Form>
          <Modal.Body>
            <Field
              as={Textarea}
              name="resolution"
              rows={4}
              placeholder="Digite sua resposta aqui..."
              value={values.resolution}
              onChange={handleChange}
            />
            <div className="text-red-500 text-sm mt-1">
              <ErrorMessage name="resolution" />
            </div>

            <Field
              as={Select}
              name="status"
              value={values.status}
              onChange={handleChange}
            >
              <option value="">Selecione um status</option>
              <option value="APPROVED">Aprovar</option>
              <option value="REJECTED">Rejeitar</option>
            </Field>

            <div className="text-red-500 text-sm mt-1">
              <ErrorMessage name="status" />
            </div>
          </Modal.Body>

          <Modal.Footer>
            <ButtonWithLoader type="submit" isLoading={isPending}>
              Enviar Resposta
            </ButtonWithLoader>
            <Button color="gray" type="button" onClick={handleClose}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Form>
        )}
      </Formik>
    </Modal>
  );
}

